import clsx from 'clsx';
import { FC } from 'react';

import { Skeleton } from 'src/general/components/Skeleton/Skeleton';

interface Props {
  variant?: 'plp' | 'default';
}

export const ProductCardLoading: FC<Props> = ({ variant = 'plp' }) => (
  <li className={clsx('ProductCard', `ProductCard-${variant}`, 'ProductCard-loading')}>
    <div className={clsx('ProductCard-image', 'ProductCard-imagePlaceholder')} />
    <p className="ProductCard-model">
      <Skeleton />
    </p>
    <p className="ProductCard-variant">
      <Skeleton size={50} />
    </p>
    <p className="ProductCard-details">
      <Skeleton size={40} />
      &ensp;•&ensp;
      <Skeleton size={40} />
    </p>
    <aside className="ProductCard-controls">{/* Empty */}</aside>
    <footer className="ProductCard-footer">
      <p className="ProductCard-price">
        <Skeleton size={50} />
      </p>
      <p className="ProductCard-repayment">
        <Skeleton />
      </p>
      {variant !== 'default' && (
        <aside className="ProductCard-footerActions">
          <div className="ProductCard-footerActionButton"></div>
          <div className="ProductCard-footerActionButton"></div>
        </aside>
      )}
    </footer>
  </li>
);
